<template>
  <div>
    <!-- Botão para desktop -->
    <q-btn
      v-if="!mobile"
      color="dark"
      text-color="dark"
      class="desktop"
      flat
      round
      :disable="
        !$store.state.autenticacao.usuarioLogado.permissoes.gmapi ||
        $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
          'pdt-emitir'
        ) == -1
      "
      icon="content_copy"
      @click="duplicar = true"
    />

    <!-- Botão para mobile -->
    <q-btn
      v-if="mobile"
      icon="content_copy"
      stack
      label="Duplicar"
      no-caps
      class="btn"
      style="color: white; background: #545454"
      :disable="
        !$store.state.autenticacao.usuarioLogado.permissoes.gmapi ||
        $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
          'pdt-emitir'
        ) == -1
      "
      @click="duplicar = true"
    />

    <q-dialog v-model="duplicar">
      <q-card style="width: 700px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">Duplicar: #{{ pt.ptId }}</div>
        </q-card-section>

        <q-form ref="duplicarForm">
          <q-card-section class="row q-col-gutter-sm">
            <q-input
              class="col-xs-12 col-sm-12 col-lg-4"
              dense
              outlined
              label="Local"
              v-model="duplicarDto.local"
              :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            >
              <template v-slot:prepend>
                <q-icon name="public" />
              </template>
            </q-input>

            <q-input
              class="col-xs-12 col-sm-6 col-lg-4"
              dense
              outlined
              label="Data e Hora de Início"
              v-model="duplicarDto.dataInicio"
              mask="##/##/#### ##:##"
              fill-mask
              placeholder="DD/MM/AAAA HH:MM"
              :rules="[
                (val) => (val && val.length > 0) || 'Campo obrigatório',
                (val) => validarDataHora(val) || 'Data/hora inválida',
              ]"
            >
              <template v-slot:append>
                <q-btn
                  flat
                  dense
                  icon="event"
                  size="md"
                  @click="abrirSeletorAvancado('inicio')"
                >
                  <q-tooltip>Selecionar data e hora</q-tooltip>
                </q-btn>
              </template>
            </q-input>

            <q-input
              class="col-xs-12 col-sm-6 col-lg-4"
              dense
              outlined
              label="Data e Hora de Término"
              v-model="duplicarDto.dataTermino"
              mask="##/##/#### ##:##"
              fill-mask
              placeholder="DD/MM/AAAA HH:MM"
              :rules="[
                (val) => (val && val.length > 0) || 'Campo obrigatório',
                (val) => validarDataHora(val) || 'Data/hora inválida',
                (val) =>
                  validarDataTermino(val) ||
                  'Data término deve ser posterior ao início',
              ]"
            >
              <template v-slot:append>
                <q-btn
                  flat
                  dense
                  icon="event"
                  size="md"
                  @click="abrirSeletorAvancado('termino')"
                >
                  <q-tooltip>Selecionar data e hora</q-tooltip>
                </q-btn>
              </template>
            </q-input>

            <q-input
              class="col-xs-12"
              dense
              outlined
              label="Descrição"
              v-model="duplicarDto.descricao"
              type="textarea"
            />
          </q-card-section>
        </q-form>

        <q-separator />

        <q-card-actions align="right">
          <q-btn
            flat
            color="primary"
            label="Duplicar"
            type="submit"
            @click="duplicarPt"
          />
          <q-btn flat color="negative" label="Fechar" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Modal para seletor avançado de data/hora -->
    <q-dialog v-model="seletorAvancado.aberto">
      <q-card style="width: 600px; min-width: 45vw">
        <q-card-section>
          <div class="text-h6">
            {{
              seletorAvancado.tipo === "inicio"
                ? "Data/Hora de Início"
                : "Data/Hora de Término"
            }}
          </div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          <!-- Atalhos rápidos -->
          <div class="q-mb-lg">
            <div class="text-subtitle2 q-mb-sm text-grey-7">
              Atalhos rápidos:
            </div>
            <div class="row q-gutter-xs">
              <template v-if="seletorAvancado.tipo === 'inicio'">
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="Agora"
                  @click="aplicarAtalho('agora')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="Amanhã 08:00"
                  @click="aplicarAtalho('amanha')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="Próxima segunda"
                  @click="aplicarAtalho('proximaSemana')"
                  class="q-px-md"
                />
              </template>
              <template v-else>
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="+2h"
                  @click="aplicarAtalho('2horas')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="+4h"
                  @click="aplicarAtalho('4horas')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="+8h"
                  @click="aplicarAtalho('8horas')"
                  class="q-px-md"
                />
                <q-btn
                  size="sm"
                  outline
                  color="primary"
                  label="17:00"
                  @click="aplicarAtalho('fimExpediente')"
                  class="q-px-md"
                />
              </template>
            </div>
          </div>

          <q-separator class="q-mb-lg" />

          <!-- Seletor manual -->
          <div class="text-subtitle2 q-mb-md text-grey-7">Seleção manual:</div>

          <!-- Layout responsivo: empilhado em mobile, lado a lado em desktop -->
          <div class="row q-col-gutter-lg">
            <!-- Calendário -->
            <div class="col-12 col-md-7">
              <div class="text-caption q-mb-sm text-grey-6">Data:</div>
              <q-date
                v-model="seletorAvancado.data"
                mask="DD/MM/YYYY"
                :locale="myLocale"
                minimal
                color="primary"
                class="full-width"
              />
            </div>

            <!-- Relógio -->
            <div class="col-12 col-md-5">
              <div class="text-caption q-mb-sm text-grey-6">Hora:</div>
              <div class="flex flex-center">
                <q-time
                  v-model="seletorAvancado.hora"
                  mask="HH:mm"
                  format24h
                  color="primary"
                />
              </div>
            </div>
          </div>
        </q-card-section>

        <q-card-actions align="right" class="q-pt-lg">
          <q-btn
            flat
            color="grey-7"
            label="Cancelar"
            v-close-popup
            class="q-mr-sm"
          />
          <q-btn
            unelevated
            color="primary"
            label="Confirmar"
            @click="confirmarSeletorAvancado"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useQuasar } from "quasar";

export default {
  props: ["pt", "mobile"],
  emits: ["closing"],
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const quasar = useQuasar();
    const duplicar = ref(false);
    const duplicarForm = ref(null);
    const seletorAvancado = ref({
      aberto: false,
      tipo: "", // 'inicio' ou 'termino'
      data: "",
      hora: "",
    });

    // Função para formatar data em formato brasileiro
    const formatarDataHoraBR = (data) => {
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const ano = data.getFullYear();
      const hora = String(data.getHours()).padStart(2, "0");
      const minuto = String(data.getMinutes()).padStart(2, "0");
      return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    };

    // Função para formatar data/hora atual
    const formatarDataHoraAtual = () => {
      const agora = new Date();
      return formatarDataHoraBR(agora);
    };

    // Função para formatar data/hora futura
    const formatarDataHoraFutura = (horas) => {
      const futura = new Date();
      futura.setHours(futura.getHours() + horas);
      return formatarDataHoraBR(futura);
    };

    let duplicarDto = ref({
      ptId: props.pt.ptId,
      local: props.pt.local,
      dataInicio: formatarDataHoraAtual(),
      dataTermino: formatarDataHoraFutura(2), // +2 horas por padrão
      descricao: props.pt.descricao,
      unidadeId: props.pt.unidadeId,
    });

    // Converter string DD/MM/YYYY HH:MM para Date
    const parsearDataHora = (valor) => {
      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
      const match = valor.match(regex);

      if (!match) return null;

      const [, dia, mes, ano, hora, minuto] = match;
      return new Date(ano, mes - 1, dia, hora, minuto);
    };

    // Ajustar data término automaticamente quando início muda
    const ajustarDataTermino = () => {
      const dataInicio = parsearDataHora(duplicarDto.value.dataInicio);
      if (!dataInicio) return;

      const dataTermino = new Date(dataInicio);
      dataTermino.setHours(dataTermino.getHours() + 2); // +2 horas por padrão

      duplicarDto.value.dataTermino = formatarDataHoraBR(dataTermino);
    };

    // Validar formato de data/hora
    const validarDataHora = (valor) => {
      if (!valor) return false;

      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
      const match = valor.match(regex);

      if (!match) return false;

      const [, dia, mes, ano, hora, minuto] = match;
      const data = new Date(ano, mes - 1, dia, hora, minuto);

      return (
        data.getDate() == dia &&
        data.getMonth() == mes - 1 &&
        data.getFullYear() == ano &&
        data.getHours() == hora &&
        data.getMinutes() == minuto
      );
    };

    // Validar se data término é posterior ao início
    const validarDataTermino = (valor) => {
      if (!valor || !duplicarDto.value.dataInicio) return true;

      const dataInicio = parsearDataHora(duplicarDto.value.dataInicio);
      const dataTermino = parsearDataHora(valor);

      if (!dataInicio || !dataTermino) return true;

      return dataTermino > dataInicio;
    };

    // Atalhos para data de início
    const setDataInicio = (tipo) => {
      const agora = new Date();

      switch (tipo) {
        case "agora":
          duplicarDto.value.dataInicio = formatarDataHoraBR(agora);
          break;
        case "amanha": {
          const amanha = new Date();
          amanha.setDate(amanha.getDate() + 1);
          amanha.setHours(8, 0, 0, 0);
          duplicarDto.value.dataInicio = formatarDataHoraBR(amanha);
          break;
        }
        case "proximaSemana": {
          const proximaSegunda = new Date();
          const diasAteSegunda = (1 + 7 - proximaSegunda.getDay()) % 7 || 7;
          proximaSegunda.setDate(proximaSegunda.getDate() + diasAteSegunda);
          proximaSegunda.setHours(8, 0, 0, 0);
          duplicarDto.value.dataInicio = formatarDataHoraBR(proximaSegunda);
          break;
        }
      }

      // Ajustar data término automaticamente
      ajustarDataTermino();
    };

    // Atalhos para data de término
    const setDataTermino = (tipo) => {
      const dataInicio = parsearDataHora(duplicarDto.value.dataInicio);
      if (!dataInicio) return;

      let dataTermino = new Date(dataInicio);

      switch (tipo) {
        case "2horas":
          dataTermino.setHours(dataTermino.getHours() + 2);
          break;
        case "4horas":
          dataTermino.setHours(dataTermino.getHours() + 4);
          break;
        case "8horas":
          dataTermino.setHours(dataTermino.getHours() + 8);
          break;
        case "fimExpediente":
          dataTermino.setHours(17, 0, 0, 0);
          // Se for depois das 17h, vai para o próximo dia
          if (dataInicio.getHours() >= 17) {
            dataTermino.setDate(dataTermino.getDate() + 1);
          }
          break;
      }

      duplicarDto.value.dataTermino = formatarDataHoraBR(dataTermino);
    };

    // Formatadores para os labels dos atalhos
    const formatarDataAtual = () => {
      return formatarDataHoraBR(new Date());
    };

    const formatarDataAmanha = () => {
      const amanha = new Date();
      amanha.setDate(amanha.getDate() + 1);
      amanha.setHours(8, 0, 0, 0);
      return formatarDataHoraBR(amanha);
    };

    const formatarProximaSegunda = () => {
      const proximaSegunda = new Date();
      const diasAteSegunda = (1 + 7 - proximaSegunda.getDay()) % 7 || 7;
      proximaSegunda.setDate(proximaSegunda.getDate() + diasAteSegunda);
      proximaSegunda.setHours(8, 0, 0, 0);
      return formatarDataHoraBR(proximaSegunda);
    };

    // Seletor avançado
    const abrirSeletorAvancado = (tipo) => {
      seletorAvancado.value.tipo = tipo;
      seletorAvancado.value.aberto = true;

      // Pré-popular com valor atual
      const valorAtual =
        tipo === "inicio"
          ? duplicarDto.value.dataInicio
          : duplicarDto.value.dataTermino;
      const dataAtual = parsearDataHora(valorAtual);

      if (dataAtual) {
        seletorAvancado.value.data =
          formatarDataHoraBR(dataAtual).split(" ")[0];
        seletorAvancado.value.hora = `${String(dataAtual.getHours()).padStart(
          2,
          "0"
        )}:${String(dataAtual.getMinutes()).padStart(2, "0")}`;
      } else {
        const agora = new Date();
        seletorAvancado.value.data = formatarDataHoraBR(agora).split(" ")[0];
        seletorAvancado.value.hora = `${String(agora.getHours()).padStart(
          2,
          "0"
        )}:${String(agora.getMinutes()).padStart(2, "0")}`;
      }
    };

    const confirmarSeletorAvancado = () => {
      const dataHoraCompleta = `${seletorAvancado.value.data} ${seletorAvancado.value.hora}`;

      if (seletorAvancado.value.tipo === "inicio") {
        duplicarDto.value.dataInicio = dataHoraCompleta;
        ajustarDataTermino();
      } else {
        duplicarDto.value.dataTermino = dataHoraCompleta;
      }

      seletorAvancado.value.aberto = false;
    };

    // Aplicar atalhos dentro do seletor avançado
    const aplicarAtalho = (tipo) => {
      let dataCalculada;

      if (seletorAvancado.value.tipo === "inicio") {
        // Atalhos para data de início
        const agora = new Date();

        switch (tipo) {
          case "agora":
            dataCalculada = agora;
            break;
          case "amanha": {
            const amanha = new Date();
            amanha.setDate(amanha.getDate() + 1);
            amanha.setHours(8, 0, 0, 0);
            dataCalculada = amanha;
            break;
          }
          case "proximaSemana": {
            const proximaSegunda = new Date();
            const diasAteSegunda = (1 + 7 - proximaSegunda.getDay()) % 7 || 7;
            proximaSegunda.setDate(proximaSegunda.getDate() + diasAteSegunda);
            proximaSegunda.setHours(8, 0, 0, 0);
            dataCalculada = proximaSegunda;
            break;
          }
        }
      } else {
        // Atalhos para data de término
        const dataInicio = parsearDataHora(duplicarDto.value.dataInicio);
        if (!dataInicio) return;

        dataCalculada = new Date(dataInicio);

        switch (tipo) {
          case "2horas":
            dataCalculada.setHours(dataCalculada.getHours() + 2);
            break;
          case "4horas":
            dataCalculada.setHours(dataCalculada.getHours() + 4);
            break;
          case "8horas":
            dataCalculada.setHours(dataCalculada.getHours() + 8);
            break;
          case "fimExpediente":
            dataCalculada.setHours(17, 0, 0, 0);
            // Se for depois das 17h, vai para o próximo dia
            if (dataInicio.getHours() >= 17) {
              dataCalculada.setDate(dataCalculada.getDate() + 1);
            }
            break;
        }
      }

      // Atualizar os valores do seletor
      if (dataCalculada) {
        seletorAvancado.value.data =
          formatarDataHoraBR(dataCalculada).split(" ")[0];
        seletorAvancado.value.hora = `${String(
          dataCalculada.getHours()
        ).padStart(2, "0")}:${String(dataCalculada.getMinutes()).padStart(
          2,
          "0"
        )}`;
      }
    };

    const duplicarPt = async () => {
      try {
        // Validar formulário antes de continuar
        if (duplicarForm.value) {
          const isValid = await duplicarForm.value.validate();
          if (!isValid) {
            quasar.notify({
              message: "Por favor, preencha todos os campos obrigatórios",
              color: "warning",
              position: "top",
              timeout: 5000,
            });
            return;
          }
        }

        // Validações adicionais
        if (!duplicarDto.value.local || duplicarDto.value.local.trim() === "") {
          quasar.notify({
            message: "O campo Local é obrigatório",
            color: "warning",
            position: "top",
            timeout: 5000,
          });
          return;
        }

        // Mostrar loading
        quasar.loading.show({
          message: "Duplicando PT...",
        });

        const dataInicio = formatarDataHora(duplicarDto.value.dataInicio);
        const dataTermino = formatarDataHora(duplicarDto.value.dataTermino);

        const resposta = await store.dispatch("pdt/duplicarPt", {
          ptId: duplicarDto.value.ptId,
          unidadeId: duplicarDto.value.unidadeId,
          local: duplicarDto.value.local,
          descricao: duplicarDto.value.descricao,
          dataHoraInicio: dataInicio,
          dataHoraTermino: dataTermino,
        });

        // Esconder loading
        quasar.loading.hide();

        // Fechar modal
        duplicar.value = false;

        // Mostrar sucesso
        quasar.notify({
          message: `PT duplicada com sucesso! Nova PT: #${resposta.data.resultado.id}`,
          color: "positive",
          position: "bottom",
          timeout: 5000,
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });

        const ptId = resposta.data.resultado.id;
        redirecionarDetalhePt(ptId);
      } catch (error) {
        console.error("❌ Erro na duplicação:", error);

        // Esconder loading
        quasar.loading.hide();

        let mensagemErro = "Erro desconhecido ao duplicar PT";
        let detalhesErro = "";

        // Extrair mensagem de erro de diferentes formatos
        if (error?.response?.data) {
          const data = error.response.data;

          // Tentar diferentes caminhos para a mensagem
          mensagemErro =
            data.message ||
            data.error ||
            data.resultado?.error ||
            data.resultado?.message ||
            data.errors?.[0]?.message ||
            data.msg ||
            "Erro no servidor ao duplicar PT";

          detalhesErro = JSON.stringify(data, null, 2);

          // Mensagens específicas por status HTTP
          if (error.response.status === 400) {
            mensagemErro = data.message || "Dados inválidos para duplicação";
          } else if (error.response.status === 401) {
            mensagemErro = "Não autorizado. Faça login novamente.";
          } else if (error.response.status === 403) {
            mensagemErro = "Sem permissão para duplicar PT";
          } else if (error.response.status === 404) {
            mensagemErro = "PT não encontrada";
          } else if (error.response.status === 422) {
            mensagemErro = data.message || "Dados de duplicação inválidos";
          } else if (error.response.status === 500) {
            mensagemErro = data.message || "Erro interno do servidor";
          }
        } else if (error?.message) {
          mensagemErro = error.message;
          detalhesErro = error.toString();
        } else if (typeof error === "string") {
          mensagemErro = error;
        }

        // Notificação de erro com detalhes
        quasar.notify({
          message: mensagemErro,
          color: "negative",
          position: "bottom",
          timeout: 10000,
          html: true,
          actions: [
            {
              label: "Ver Detalhes",
              color: "white",
              handler: () => {
                quasar.notify({
                  message: `<strong>Detalhes técnicos:</strong><br/><pre style="font-size: 11px; max-height: 200px; overflow-y: auto;">${detalhesErro}</pre>`,
                  color: "info",
                  position: "center",
                  timeout: 15000,
                  html: true,
                  actions: [
                    {
                      label: "Fechar",
                      color: "white",
                      handler: () => {},
                    },
                  ],
                });
              },
            },
            {
              label: "Fechar",
              color: "white",
              handler: () => {},
            },
          ],
        });
      }
    };

    const formatarDataHora = (valor) => {
      // Se já está no formato DD/MM/YYYY HH:MM, converter para YYYY/MM/DD HH:MM
      const regex = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/;
      const match = valor.match(regex);

      if (match) {
        const [, dia, mes, ano, hora, minuto] = match;
        return `${ano}/${mes}/${dia} ${hora}:${minuto}:00`;
      }

      // Fallback para formato antigo (se ainda existir)
      if (valor.includes(" ")) {
        let hora = valor.split(" ")[1];
        let data = valor.split(" ")[0].split("/").reverse().join("/");
        return `${data} ${hora}`;
      }

      return valor;
    };

    const redirecionarDetalhePt = (ptId) => {
      router.push({ name: "pdt-pt-detalhe", params: { ptId } });
    };

    return {
      duplicar,
      duplicarForm,
      duplicarDto,
      duplicarPt,
      seletorAvancado,
      validarDataHora,
      validarDataTermino,
      setDataInicio,
      setDataTermino,
      formatarDataAtual,
      formatarDataAmanha,
      formatarProximaSegunda,
      abrirSeletorAvancado,
      confirmarSeletorAvancado,
      aplicarAtalho,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .btn {
    border-radius: 0px !important;
    font-size: 12px !important;
    min-height: 44px !important;
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .btn {
    font-size: 11px !important;
    min-height: 49px !important;
  }
}

@media (max-width: 360px) {
  .btn {
    font-size: 10px !important;
    min-height: 40px !important;
  }
}

/* Estilos para melhorar a usabilidade dos inputs */
.q-field--outlined .q-field__control:before {
  border-color: #e0e0e0;
}

.q-field--outlined.q-field--focused .q-field__control:before {
  border-color: #1976d2;
  border-width: 2px;
}

/* Dropdown de atalhos */
.q-btn-dropdown {
  min-width: auto;
}

.q-item__label--caption {
  font-size: 11px;
  opacity: 0.7;
}

/* Modal seletor avançado */
.q-date {
  box-shadow: none;
}

.q-time {
  box-shadow: none;
}

/* Responsividade do modal de data/hora */
@media (max-width: 768px) {
  .q-date {
    width: 100% !important;
  }

  .q-time {
    width: 100% !important;
    margin: 0 auto;
  }
}

/* Melhorar espaçamento dos botões de atalho */
.q-btn.outline {
  border: 1px solid currentColor;
}

/* Garantir que o calendário ocupe toda a largura disponível */
.q-date.full-width {
  width: 100%;
  max-width: 100%;
}
</style>
